import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { DContext } from '../../context/DataContext'
import LoadingPage from './Loading'
import { useTranslation } from 'react-i18next'
import { FiArrowRight, FiPlus } from 'react-icons/fi'
import Carousel from '../blocks/Carousel'
import DestinationIcon from '../../assets/destination.png'
import MetaData from '../../utils/MetaData'


function PackageInfo() {
    const { t } = useTranslation()
    const { packagePath } = useParams()
    const { cart, setCart, filteredPackages, currency } = useContext(DContext)
    const [selectedPrice, setSelectedPrice] = useState(null)
    const navPage = useNavigate()
    const [currentPackage, setCurrentPackage] = useState(null)

    console.log("packagePath:", packagePath)
    console.log("currentPackage:", currentPackage)
    console.log("packages in page:", filteredPackages)

    useEffect(() => {
        if (filteredPackages && packagePath) {
            const nextPackage = filteredPackages.find((packageItem) => packageItem.path === packagePath)
            setCurrentPackage(nextPackage || null)
        }
    }, [packagePath, filteredPackages])


    if (currentPackage === null) {
        return <LoadingPage />
    }

    const handleBucketList = (isCategory) => {
        if (isCategory && !selectedPrice) {
            alert(t("packageDetails.pleaseSelectPackageCategory"))
            return
        }
        const isExist = cart.some(item => item.id === currentPackage.id)
        if (!isExist) {
            setCart(prev => {
                let newCart = [...prev]
                const currentItem = {
                    id: currentPackage.id,
                    pkg: selectedPrice
                }
                newCart.push(currentItem)
                return newCart
            })
        }
        alert(t("packageInfoPage.added"))
    }

    const handleBooking = (isCategory) => {
        if (isCategory && !selectedPrice) {
            alert(t("packageDetails.pleaseSelectPackageCategory"))
            return
        }
        const isExist = cart.some(item => item.id === currentPackage.id)
        if (!isExist) {
            setCart(prev => {
                let newCart = [...prev]
                const currentItem = {
                    id: currentPackage.id,
                    pkg: selectedPrice
                }
                newCart.push(currentItem)
                return newCart
            })
        }
        navPage(`/bucket-list`)
    }

    const currencyLabel = currency === 'usd' ? t('packagePage.currency.usd') : t('packagePage.currency.thb')
    const currencySymbol = currency === 'usd' ? '$' : '฿'

    const renderSelectedPrice = () => {
        if (selectedPrice && currentPackage && currency) {
            if (selectedPrice === "price") {
                return currentPackage.price[currency].adult
            }
            else if (selectedPrice === "halfPrice") {
                return currentPackage.halfPrice[currency].adult
            }
            else if (selectedPrice === "speedBoat") {
                return currentPackage.speedBoatPrice[currency].adult
            }
            else if (selectedPrice === "longTail") {
                return currentPackage.longTailPrice[currency].adult
            }
        }
    }

    if (!currentPackage) {
        return <LoadingPage />
    }

    const siteUrl = window.location.origin
    const pageUrl = `${siteUrl}/package/${currentPackage.path}`
    const firstImage = Array.isArray(currentPackage.img) && currentPackage.img.length > 0 ? currentPackage.img[0] : ''
    const description = typeof currentPackage.desc === 'string' ? currentPackage.desc : ''
    const offerCandidates = []

    if (currentPackage.priceType === 'pkg') {
        offerCandidates.push({ name: 'Full Day', price: currentPackage.price?.thb?.adult })
        if (currentPackage.isHalfPrice) {
            offerCandidates.push({ name: 'Half Day', price: currentPackage.halfPrice?.thb?.adult })
        }
    }

    if (currentPackage.priceType === 'boat') {
        offerCandidates.push({ name: 'Speed Boat', price: currentPackage.speedBoatPrice?.thb?.adult })
        if (currentPackage.isLongTailPrice) {
            offerCandidates.push({ name: 'Longtail Boat', price: currentPackage.longTailPrice?.thb?.adult })
        }
    }

    const offers = offerCandidates
        .map((item) => ({ ...item, price: Number(item.price) }))
        .filter((item) => Number.isFinite(item.price) && item.price > 0)
        .map((item) => ({
            '@type': 'Offer',
            name: item.name,
            price: item.price,
            priceCurrency: 'THB',
            availability: 'https://schema.org/InStock',
            url: pageUrl
        }))

    const packageJsonLd = {
        '@context': 'https://schema.org',
        '@type': 'TouristTrip',
        name: currentPackage.title,
        description,
        url: pageUrl,
        image: firstImage ? [firstImage] : undefined,
        offers,
        areaServed: {
            '@type': 'Place',
            name: 'Krabi, Thailand'
        }
    }

    return (
        <>
            <MetaData
                title={`${currentPackage.title} | Be Alright Krabi`}
                description={description}
                keywords={`${currentPackage.title}, Krabi tours, Thailand tourism, Krabi activities, Be Alright Krabi`}
                canonicalUrl={pageUrl}
                ogTitle={`${currentPackage.title} | Be Alright Krabi`}
                ogDescription={description}
                ogImage={firstImage}
                ogType='product'
                structuredData={packageJsonLd}
                structuredDataId='package-jsonld'
            />
            <div className='mx-auto my-4 w-[94%] max-w-6xl'>
                {/* <h2>{t("packageInfoPage.title")}</h2> */}
                <nav className='mb-3' aria-label='breadcrumb'>
                    <ol className='flex flex-wrap items-center gap-2 text-sm text-slate-500'>
                        <li><a href='/' className='font-medium text-slate-600 transition hover:text-[#1739bd]'>{t("sliderMenu.home")}</a></li>
                        <li>/</li>
                        <li><a href='/packages' className='font-medium text-slate-600 transition hover:text-[#1739bd]'>{t("sliderMenu.tourPackages")}</a></li>
                        <li>/</li>
                        <li className='font-semibold text-slate-700' aria-current='page'>{t("packageInfoPage.title")}</li>
                    </ol>
                </nav>
                <div>
                    <div className='grid grid-cols-1 gap-3 lg:grid-cols-12'>
                        <Carousel Images={currentPackage.img} />
                        <img className='w-full rounded-3xl object-cover lg:col-span-4' src={currentPackage.img[1]} alt={currentPackage.name} style={{ height: '250px' }} />
                        <img className='w-full rounded-3xl object-cover lg:col-span-4' src={currentPackage.img[2]} alt={currentPackage.name} style={{ height: '250px' }} />
                        <img className='w-full rounded-3xl object-cover lg:col-span-4' src={currentPackage.img[3]} alt={currentPackage.name} style={{ height: '250px' }} />
                    </div>
                    <div className='my-4 rounded-3xl border border-slate-200 bg-white p-5 shadow-sm'>
                        <h2 className='text-3xl font-black text-[#1739bd]'>{currentPackage.title}</h2>
                        <p className='mt-2 text-slate-700'>{currentPackage.desc}</p>
                        <dl>
                            <dt><b>{t("packageInfoPage.destinations")}:</b></dt>
                            <dd>
                                <ul style={{ listStyleType: 'none' }}>
                                    {
                                        currentPackage && currentPackage.destinations.map((destination, i) => {
                                            return <li key={i} className='mb-1 inline-flex items-center'>
                                                <img
                                                    src={DestinationIcon}
                                                    alt="Destination Icon"
                                                    className='mr-3'
                                                    style={{ width: '20px', height: '20px', objectFit: 'contain' }}
                                                />
                                                {destination}
                                            </li>
                                        })
                                    }
                                </ul>
                            </dd>
                        </dl>
                        <dl>
                            <dt><b>{t("packageInfoPage.activities")}:</b></dt>
                            <dl>
                                <ul>
                                    {
                                        Object.values(currentPackage.activities).map((activity, i) => {
                                            return <li key={i}>{activity}</li>
                                        })
                                    }
                                </ul>
                            </dl>
                        </dl>

                        <dl>
                            <dt><b>{t("packageDetails.packageCategory")}:</b></dt>
                            <dd className='overflow-x-auto rounded-2xl border border-slate-200'>
                                <table className='min-w-full divide-y divide-slate-200'>
                                    <thead className='bg-slate-100/80'>
                                        <tr>
                                            <th className='px-4 py-3 text-left text-xs font-semibold uppercase tracking-[0.1em] text-slate-600'>{t("packageDetails.category")}</th>
                                            <th className='px-4 py-3 text-left text-xs font-semibold uppercase tracking-[0.1em] text-slate-600'>{t("packageDetails.adult")}</th>
                                            <th className='px-4 py-3 text-left text-xs font-semibold uppercase tracking-[0.1em] text-slate-600'>{t("packageDetails.kid")}</th>
                                        </tr>
                                    </thead>
                                    <tbody className='divide-y divide-slate-100 text-sm text-slate-700'>
                                        {
                                            currentPackage.priceType === "pkg" ?
                                                <>
                                                    <tr>
                                                        <td>{t("packageDetails.fullDay")}</td>
                                                        <td>{`${currencySymbol} ${currentPackage.price[currency].adult || '-'} ${currencyLabel}`}</td>
                                                        <td>{`${currencySymbol} ${currentPackage.price[currency].kid || '-'} ${currencyLabel}`}</td>
                                                    </tr>
                                                    {currentPackage.isHalfPrice &&
                                                        <tr>
                                                            <td>{t("packageDetails.halfDay")}</td>
                                                            <td>{`${currencySymbol} ${currentPackage.halfPrice[currency].adult || '-'} ${currencyLabel}`}</td>
                                                            <td>{`${currencySymbol} ${currentPackage.halfPrice[currency].kid || '-'} ${currencyLabel}`}</td>
                                                        </tr>}
                                                </>
                                                :
                                                <>
                                                    <tr>
                                                        <td>{t("packageDetails.speedBoat")}</td>
                                                        <td>{`${currencySymbol} ${currentPackage.speedBoatPrice[currency].adult || '-'} ${currencyLabel}`}</td>
                                                        <td>{`${currencySymbol} ${currentPackage.speedBoatPrice[currency].kid || '-'} ${currencyLabel}`}</td>
                                                    </tr>
                                                    {currentPackage.isLongTailPrice &&
                                                        <tr>
                                                            <td>{t("packageDetails.longtailBoat")}</td>
                                                            <td>{`${currencySymbol} ${currentPackage.longTailPrice[currency].adult || '-'} ${currencyLabel}`}</td>
                                                            <td>{`${currencySymbol} ${currentPackage.longTailPrice[currency].kid || '-'} ${currencyLabel}`}</td>
                                                        </tr>}
                                                </>
                                        }

                                        {
                                            currentPackage.isEntranceFees &&
                                            <tr>
                                                <td>{t("packageDetails.entranceFees")}</td>
                                                <td className='px-4 py-3 text-center' colSpan={2}>{`${currencySymbol} ${currentPackage.entranceFees[currency] || '-'} ${currencyLabel}`}</td>
                                            </tr>
                                        }

                                    </tbody>
                                </table>
                            </dd>

                            {
                                (currentPackage.priceType === "pkg" && currentPackage.isHalfPrice) &&
                                <dd className='text-center'>
                                    <h4>{t("packageDetails.selectPackageCategoryForBooking")}</h4>
                                    <div className='my-3 flex flex-wrap justify-center gap-3'>
                                        <span className='inline-flex items-center gap-2 rounded-full border border-slate-300 px-3 py-1.5'>
                                            <input className='h-4 w-4 rounded border-slate-300 text-[#1739bd] focus:ring-[#1739bd]' required type='radio' onClick={(e) => setSelectedPrice(e.target.value)} name='price' id='price' value='price' />
                                            <label className='text-sm font-medium text-slate-700' htmlFor='price'>{t("packageDetails.fullDay")}</label>
                                        </span>
                                        <span className='inline-flex items-center gap-2 rounded-full border border-slate-300 px-3 py-1.5'>
                                            <input className='h-4 w-4 rounded border-slate-300 text-[#1739bd] focus:ring-[#1739bd]' required type='radio' onClick={(e) => setSelectedPrice(e.target.value)} name='price' id='halfPrice' value='halfPrice' />
                                            <label className='text-sm font-medium text-slate-700' htmlFor='halfPrice'>{t("packageDetails.halfDay")}</label>
                                        </span>
                                    </div>
                                    <h5 className={`${renderSelectedPrice() ? "font-semibold text-slate-900" : "font-normal text-slate-500"}`}>{t("packageDetails.price")}: <span>{`${currencySymbol} ${renderSelectedPrice() || ''} ${currencyLabel}`}</span></h5>
                                </dd>
                            }

                            {
                                (currentPackage.priceType === "boat" && currentPackage.isLongTailPrice) &&
                                <dd className='text-center'>
                                    <h4>{t("packageDetails.selectPackageCategoryForBooking")}</h4>
                                    <div className='my-3 flex flex-wrap justify-center gap-3'>
                                        <span className='inline-flex items-center gap-2 rounded-full border border-slate-300 px-3 py-1.5'>
                                            <input className='h-4 w-4 rounded border-slate-300 text-[#1739bd] focus:ring-[#1739bd]' required type='radio' onClick={(e) => setSelectedPrice(e.target.value)} name='boat' id='price' value='speedBoat' />
                                            <label className='text-sm font-medium text-slate-700' htmlFor='price'>{t("packageDetails.speedBoat")}</label>
                                        </span>
                                        <span className='inline-flex items-center gap-2 rounded-full border border-slate-300 px-3 py-1.5'>
                                            <input className='h-4 w-4 rounded border-slate-300 text-[#1739bd] focus:ring-[#1739bd]' required type='radio' onClick={(e) => setSelectedPrice(e.target.value)} name='boat' id='halfPrice' value='longTail' />
                                            <label className='text-sm font-medium text-slate-700' htmlFor='halfPrice'>{t("packageDetails.longtailBoat")}</label>
                                        </span>
                                    </div>
                                    <h5>{t("packageDetails.price")}: <span>{`${currencySymbol} ${renderSelectedPrice() || ''} ${currencyLabel}`}</span></h5>
                                </dd>
                            }

                        </dl>

                        <div className='flex flex-wrap items-center justify-center gap-3'>
                            <button className='inline-flex items-center gap-2 rounded-full border border-[#1739bd] px-5 py-3 text-lg font-semibold text-[#1739bd] transition hover:bg-[#1739bd] hover:text-white' onClick={() => handleBucketList(currentPackage.isHalfPrice || currentPackage.isLongTailPrice)}>{t("packageInfoPage.add")} <FiPlus className='btn-arrow' /></button>
                            <button className='sk-btn inline-flex items-center gap-2 whitespace-nowrap text-lg rounded-full' onClick={() => handleBooking(currentPackage.isHalfPrice || currentPackage.isLongTailPrice)}>{t("packageInfoPage.book")} <FiArrowRight className='btn-arrow' /></button>
                        </div>


                    </div>
                </div>
            </div>
        </>
    )
}

export default PackageInfo